import { Modal, Table, InputNumber, Input, Typography, Form, Popconfirm } from "antd";
import React from "react";
import { useState , useEffect} from 'react';
import { FinalAssessmentService } from "../../../services/FinalAssessmentService";
import { useParams } from 'react-router';
const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          // rules={[
          //   {
          //     required: true,
          //     message: `Please Input ${title}!`,
          //   },
          // ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const FinalExamAssessmentPage = ({ isModalOpen, onCancel, data, loading }) => {

  const { teacherId, streamId } = useParams();
  const [form] = Form.useForm();
  const [data1, setData1] = useState(data);
  const [editingKey, setEditingKey] = useState('');
  const [loading1, setLoading] = React.useState(false);
  const isEditing = (record) => record.key === editingKey;
  

  useEffect(() => {
    setData1(data)
  
  }, [data, loading]);
  
  const edit = (record) => {
    
    form.setFieldsValue({
      student: '',
      finalAssessment: '',
      ...record,
    });
    setEditingKey(record.key);
    
  };
  const cancel = () => {
    setEditingKey('');
  };
  const save = async (record) => {
    
      const row = await form.validateFields();
      
      const newData = [...data1];
      const index = newData.findIndex((item) => record.key === item.key);
      
      console.log(index)
      if (record.finalAssessment != null) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData1(newData);
        
        setEditingKey('');
        console.log(data1)
        FinalAssessmentService.updateFinalExamAssessmentByStreamId(record.assessmentId , {
          assessment: row.finalAssessment,
          academicStream: streamId,
          student: record.key,
    })
      .then(() => console.log(newData))
      .catch((err) => console.log(err.message))
      .finally(() => {
        setLoading(true);
        cancel();
      });
       
     
      
  } else {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData1(newData);
        setEditingKey('');
    FinalAssessmentService.createFinalExamAssessmentByStreamId({
      assessment: row.finalAssessment,
      academicStream: streamId,
      student: record.key,
})
  .then(() => {console.log(newData)})
  .catch((err) => console.log(err.message))
  .finally(() => {
    setLoading(true);
    cancel();
  });
  }
  };

  const columns = [
    {
      title: "Студент",
      dataIndex: "student",
      key: "student",
      sorter: (a, b) => a.student.localeCompare(b.student),
      width: 250,
      fixed: true,
      
      render: (student) => (
        <Typography.Title level={4} style={{ margin: 0 }}>
          {student}
        </Typography.Title>
      ),
    },
    {
      title: "Итоговая оценка",
      dataIndex: "finalAssessment",
      key: "finalAssessment",
      editable: true,
      render: (assessment) => (
        <Typography.Title level={4} style={{ margin: 0 }}>
          {assessment}
        </Typography.Title>
      ),
    },
    {
      title: 'operation',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record)}
              style={{
                marginRight: 8,
              }}
            >
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
            Edit
          </Typography.Link>
        );
      },
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'age' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Modal
      title={"Итоговые оценки"}
      visible={isModalOpen}
      onCancel={onCancel}
      footer={null}
      bodyStyle={{ minHeight: 800, paddingTop: 0 }}
    >
      <Form form={form} component={false}>
      <Table
      components={{
          body: {
            cell: EditableCell,
          },
        }}
        columns={mergedColumns}
        dataSource={data1}
        bordered
        rowClassName="editable-row"
        pagination={{ position: ["topLeft"], pageSize: 15 }}
        size={"small"}
        loading={loading}
      />
      </Form>
    </Modal>
  );
};

export default FinalExamAssessmentPage;

